import { useEffect, useState } from 'react';
import './style.css';
import ButtonComponent from '../../components/button/button';
import AccessibilityControls from '../../components/accessibilty/accessibility-controls';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../shared/context/a11y-context';

const Instruction = () => {
  const navigate = useNavigate();
  const [fontSizeLevel, setFontSizeLevel] = useState(0);
  const { screenReaderEnabled, announceMessage } = useAccessibility();

  const handleNext = () => {
    navigate('/questions');
  };

  const handleFontSizeChange = (level: number) => {
    setFontSizeLevel(level);
  };

  const getFontSizeClass = () => {
    switch (fontSizeLevel) {
      case 0: return 'font-level-0';
      case 1: return 'font-level-1';
      case 2: return 'font-level-2';
      case 3: return 'font-level-3';
      case 4: return 'font-level-4';
      default: return 'font-level-0';
    }
  };

  // 🔊 Quando a tela carregar E o modo leitor estiver ativo, lê o conteúdo
  useEffect(() => {
    if (!screenReaderEnabled) return;

    const container = document.querySelector('[data-main-content]');
    const text = container?.textContent?.trim() || '';

    if (text) {
      const resumo = text.slice(0, 800);
      announceMessage(resumo, 'polite');
    }
  }, [screenReaderEnabled, announceMessage]);

  return (
    <>
      <AccessibilityControls onFontSizeChange={handleFontSizeChange} />

      <div
        className={`instruction-container ${getFontSizeClass()}`}
        data-main-content
      >
        <p>Agora você vai fazer uma atividade de escolhas.</p>
        <p>
          Em cada pergunta, você vai ter duas opções: uma delas mostra uma
          quantidade de dinheiro que você poderia ganhar agora e a outra mostra
          uma quantia maior, mas que você só ganharia depois de um tempo.
        </p>
        <p>
          Não existe certo ou errado, mas o importante é o que você responda
          pensando no que realmente preferiria se fosse de verdade.
        </p>

        <ButtonComponent label="Começar" onClick={handleNext} />
      </div>
    </>
  );
};

export default Instruction;
